module.exports = __webpack_public_path__ + "img/12.cc4722b9.jpg";